// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa240.stage.monatest.icu/auto-open-api-spec.yaml 1.6.65
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';

/**
 * Serialize Practitioner Shift from database
 * @see #/components/schemas/PractitionerShift - reference to schema in open-api-spec.yaml
 * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
 * @version 1.6.65
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface PractitionerShift {
    /**
     * The practitioner shift  * `morning` - Morning * `midday` - Midday * `evening` - Evening
     *
     */
    shift: PractitionerShift.ShiftEnum;
    /**
     * The practitioner shift start time.
     * @dataFormat time
     */
    start: string;
    /**
     * The practitioner shift end time.
     * @dataFormat time
     */
    end?: string;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for PractitionerShift
 */
export namespace PractitionerShift {
    export type ShiftEnum = 'morning' | 'midday' | 'evening';
    export const ShiftEnum = {
        Morning: 'morning' as ShiftEnum,
        Midday: 'midday' as ShiftEnum,
        Evening: 'evening' as ShiftEnum,
    };

    /**
     * PractitionerShift Frontend Model with camelCase properties
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        /**
         * The practitioner shift  * `morning` - Morning * `midday` - Midday * `evening` - Evening
         * @type string (`dataFormat` is missing)
         */
        shift: PractitionerShift.ShiftEnum;
        /**
         * The practitioner shift start time.
         * @dataFormat time
         */
        start: string;
        /**
         * The practitioner shift end time.
         * @dataFormat time
         */
        end?: string;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * PractitionerShift DTO
     * Transforms PractitionerShift model from/to API object
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend PractitionerShift model */
        static toModel(obj: PractitionerShift): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend PractitionerShift model */
        static toApi(obj: Model): PractitionerShift {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as PractitionerShift;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
